module.exports = __webpack_public_path__ + "media/images/main_marketapp-eb531038.jpg";